
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  updataLevelToFaultCode,
  updatTypeToFaultCode,
  getAlarmSetPage
} from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiAllConfigTable extends Vue {
  @Prop({ default: "" }) private pageType!: string;
  @Prop({
    default: () => {
      return [];
    }
  })
  private gradeList!: objAny[];
  @Prop({
    default: () => {
      return [];
    }
  })
  private typeList!: objAny[];
  private formInlineTable: objAny = {
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private loadingTable = false;
  private total = 0;
  private formInline: objAny = {
    alarmType: "",
    faultCodes: [],
    alarmLevel: ""
  };
  private loading = false;
  private selectList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("alarmSet.faultName"),
      key: "faultName",
      minWidth: 120
    },
    {
      title: i18n.t("alarmSet.faultEnName"),
      key: "faultEnName",
      minWidth: 120
    },
    {
      title: i18n.t("alarmSet.faultCode"),
      key: "faultCode",
      minWidth: 120
    }
  ];
  private ruleInline: objAny = {
    alarmLevel: [
      {
        required: true,
        message: i18n.t("alarmSet.alarmLevelPl"),
        trigger: "change"
        // type: "number"
      }
    ],
    alarmType: [
      {
        required: true,
        message: i18n.t("alarmSet.alarmTypePl"),
        trigger: "change"
        // type: "number"
      }
    ]
  };
  private formObj: objAny = {};

  public init() {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
    if (this.tableList.length == 0) {
      this.queryTable();
    }
  }
  public selectItem(list: object[]) {
    this.selectList = list;
  }

  public closeModel() {
    this.$emit("close");
  }

  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData() {
    const faultCodes: string[] = [];
    this.selectList.map((item: objAny) => {
      faultCodes.push(item.faultCode);
    });
    if (faultCodes.length == 0) {
      this.$Message.error(i18n.t("alarmSet.configDataPl"));
      return;
    }

    let ret;
    if (this.pageType == "grade") {
      ret = await updataLevelToFaultCode({
        alarmLevel: this.formInline.alarmLevel,
        faultCodes: faultCodes
      });
    } else {
      ret = await updatTypeToFaultCode({
        alarmType: this.formInline.alarmType,
        faultCodes: faultCodes
      });
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("alarmSet.configSuccess"));
      this.$emit("success");
      this.closeModel();
    }
  }
  public queryTable() {
    this.formInlineTable.globalPageIndex = 1;
    this.getTableList();
  }
  public tableChange(val: number) {
    this.formInlineTable.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInlineTable.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loadingTable = true;

    const ret = await getAlarmSetPage(this.formInlineTable);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.selectList = [];
    this.loadingTable = false;
  }

  mounted() {
    this.init();
  }
}
